import styles from "./LevelPlacementsLayer.module.css";

const getTransformValue = (placement) => {
  const [x, y] = placement.displayXY();
  return `translate(${x}px, ${y}px)`;
};

export default function LevelPlacementsLayer({ level }) {
  const placements = level.placements
    .filter((p) => {
      const isInBounds = p.x <= level.tilesWidth && p.y <= level.tilesHeight;
      return isInBounds && p.appearsOnScreen();
    })
    .map((p) => {
      return (
        <div
          key={p.id}
          className={styles.placementCell}
          style={{
            // left: p.x * CELL_SIZE,
            // top: p.y * CELL_SIZE,
            transform: getTransformValue(p),
            // transform: `translate3d(${p.x * CELL_SIZE}px,${
            //   p.y * CELL_SIZE
            // }px,0)`,
            //transform: `translate(${p.x * CELL_SIZE}px,${p.y * CELL_SIZE}px)`,
            zIndex: p.getZIndex(),
          }}
        >
          {p.renderComponent()}
        </div>
      );
    });

  return placements;
}
